export const incidentReducer = (state = null, action) => {
    switch (action.type) {
      case "INCIDENT":
        return action.payload;
  
      default:
        return state;
    }
  };
  